export default __webpack_public_path__ + "static/media/SEC3050.34I-41356_-24653_0.2f5b1cee.jpg";